import _extends from "@babel/runtime/helpers/extends";
import { Box, Button } from '@wix/design-system';
import { ChevronRight } from '@wix/wix-ui-icons-common/lazy';
import clsx from 'clsx';
import React, { useCallback, useMemo } from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './resultsSearchBarV4.scss';
const SearchContainer = _ref => {
  let {
    children,
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "vertical",
    backgroundColor: "#FFFFFF",
    width: "100%",
    zIndex: 1
  }, props, {
    className: clsx(s.searchContainer, className)
  }), children);
};
const InputContainer = _ref2 => {
  let {
    children,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "horizontal",
    verticalAlign: "middle",
    align: "space-between",
    width: "100%",
    padding: "12px",
    flex: 1,
    gap: "SP1"
  }, props), children);
};
const ToolBarContainer = () => /*#__PURE__*/React.createElement(React.Fragment, null);
export const useResultsSearchBarV4Layouts = () => {
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const ActionButton = useCallback(_ref3 => {
    let {
      children: _icon,
      size: _size,
      priority: _priority,
      ...props
    } = _ref3;
    return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
      size: "large",
      skin: "dark",
      priority: "secondary",
      suffixIcon: /*#__PURE__*/React.createElement(ChevronRight, null)
    }), t('domains_search_gate.gate_revamp.searchbar.submit.cta'));
  }, [t]);
  return useMemo(() => ({
    SearchContainer,
    InputContainer,
    ActionButton,
    ToolBarContainer
  }), [ActionButton]);
};
//# sourceMappingURL=resultsSearchBarV4Layouts.js.map